

























import { snakeCase } from 'lodash'
import Vue from 'vue'
import i18n from 'vue-i18n'
import { Component, Prop } from 'vue-property-decorator'

import { LabelsAction } from '../../../../../../Action/logic/Actions/LabelsAction/LabelsAction'

@Component({
  data() {
    return {
      snakeCase,
    }
  }
})
export default class LabelsValues extends Vue {
  @Prop() action!: LabelsAction

  @Prop() i18n!: i18n

  @Prop() getLabels!: () => { [key: string]: string }
}
